import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from 'react-bootstrap';
import { sendConfirmationEmail } from '../../../userUtils';

function ReferralRow({ referral, csrfToken, userType }) {
  const sendReminderEmail = (event) => {
    event.preventDefault();
    sendConfirmationEmail(
      event,
      referral.resend_invitation_link,
      referral.email,
      csrfToken,
      `${userType === 'consultant' ? 'Consultant' : 'Employer'} Referral Program`,
      'Reminder sent!',
    );
  };
  const progressClass = referral.ignored ? 'bg-default-light' : 'bg-primary-light';
  const hideProgressClass = referral.ignored || referral.completed ? 'd-none d-sm-block' : '';

  return (
    <div className="referral-row row body-text-2">
      <div className={`col-sm-2 referral-id ${referral.ignored ? 'text-muted' : ''}`}>{referral.user_identifier}</div>
      <div className={`col-sm-8 small ${progressClass} ${hideProgressClass}`}>
        <ProgressBar now={referral.percent_complete} />
      </div>
      <div className="col-sm-2">
        {referral.reward_claimed && <span className="signed-up">Reward claimed!</span>}
        {referral.ignored && <span className="signed-up text-muted">Already a member!</span>}
        {referral.completed
        && !referral.reward_claimed
        && (
        <span>
          <span className="line-one">Successful Referral!</span>
          <span className="line-two">Check your inbox.</span>
        </span>
        )}
        {referral.pending
        && (
        <span>
          <span className="line-one">Pending invitation.</span>
          <span className="line-two">
            <a
              href="# "
              role="button"
              className={`${userType}-send-referral-reminder`}
              onClick={sendReminderEmail}
            >
              Send a reminder?
            </a>
          </span>
        </span>
        )}
      </div>
      <div className="border" />
    </div>
  );
}

ReferralRow.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  referral: PropTypes.shape({}).isRequired,
  userType: PropTypes.bool.isRequired,
};

class ReferralsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };

    this.showAll = this.showAll.bind(this);
  }

  showAll() {
    const { show } = this.state;
    this.setState({ show: !show });
  }

  render() {
    const {
      referrals, userType, csrfToken, headerTitle,
    } = this.props;
    const { show } = this.state;
    const sortedReferrals = referrals.sort((a, b) => b.percent_complete - a.percent_complete);
    const referralsToShow = show ? sortedReferrals : sortedReferrals.slice(0, 5);

    if (referrals.length > 0) {
      return (
        <div>
          <h1 className=" mb-3 ">{headerTitle}</h1>
          <div className="row referral-header  mb-3  d-none d-sm-block">
            <span className="col-sm-2" />
            <span className="col-sm-2 text-center body-text-2 medium-demibold">Invited</span>
            <span className="col-sm-2 text-center body-text-2 medium-demibold">Signed up</span>
            <span className="col-sm-2 text-center body-text-2 medium-demibold">
              {userType === 'consultant' ? 'Applied' : (
                <span>
                  Project
                  <br />
                  published
                </span>
              )}
            </span>
            <span className="col-sm-2 text-center body-text-2 medium-demibold">
              {userType === 'consultant' ? 'Hired' : (
                <span>
                  Project
                  <br />
                  matched
                </span>
              )}
            </span>
            <span className="col-sm-2" />
          </div>

          {referralsToShow.map((referral) => (
            <ReferralRow
              referral={referral}
              key={`referral-${referral.id}`}
              csrfToken={csrfToken}
              userType={userType}
            />
          ))}

          {referrals.length > 5
            && (
            <div className="text-center">
              <button type="button" className="btn btn-secondary" onClick={() => this.showAll()}>
                {show ? 'View fewer invites' : `Show all invites (${referrals.length})`}
              </button>
            </div>
            )}
        </div>
      );
    }
    return null;
  }
}

ReferralsList.propTypes = {
  referrals: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  headerTitle: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  userType: PropTypes.bool.isRequired,
};

ReferralsList.defaultProps = {
  headerTitle: null,
};

export default ReferralsList;
